import { useRouteSeo } from "../lib/seo";
import HeroSection from "../components/sections/HeroSection";
import MarqueeSection from "../components/sections/MarqueeSection";
import ServicesSection from "../components/sections/ServicesSection";
import BenefitsSection from "../components/sections/BenefitsSection";
import ProcessSection from "../components/sections/ProcessSection";
import ContactSection from "../components/sections/ContactSection";

const LandingPage = () => {
  useRouteSeo("/");

  return (
    <main data-testid="landing-page">
      <HeroSection />
      <MarqueeSection />
      <ServicesSection />
      <BenefitsSection />
      <ProcessSection />
      <ContactSection />
    </main>
  );
};

export default LandingPage;
